/*
  movtech — kosár-extrák takarítása
  ---------------------------------------------------------------------------
  Az „SOS kiszállítás" és a „Csomag biztosítás" csak akkor értelmes, ha van a
  kosárban szállítandó termék. A kosár ajánlója ezért meg sem jelenik, ha nincs
  ilyen tétel (lásd cart-drawer.liquid és main-cart-items.liquid).

  Marad egy rés: a vásárló előbb beteszi az extrát egy készülék mellé, aztán
  kiveszi a készüléket, és az extra bent ragad. Ezt takarítja ez a szkript: ha a
  kosárban nem maradt szállítandó tétel, az extrákat kiveszi belőle.

  A handle-listát a theme.liquid adja át (window.movtechKosarExtra): a „Népszerű
  extrák" beállításból azok a termékek, amelyek maguk nem igényelnek szállítást.
  Ha később fizikai terméket tesznek az ajánlóba, azt ez nem bántja.
*/
(function () {
  "use strict";

  var beallitas = window.movtechKosarExtra;
  if (!beallitas || !beallitas.handles || !beallitas.handles.length) return;

  var gyoker =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    "/";
  var fut = false;

  function kosarLekeres() {
    return fetch(gyoker + "cart.js", {
      headers: { Accept: "application/json" },
    }).then(function (valasz) {
      return valasz.ok ? valasz.json() : null;
    });
  }

  // Kulcs (line item key) szerinti törlés, egyetlen kéréssel. Szándékosan nem
  // sorszám (line) alapján megy: a sorszámok az első törlés után elcsúsznak, a
  // kulcs viszont a tételhez tartozik.
  function torles(kulcsok) {
    var frissitesek = {};
    kulcsok.forEach(function (kulcs) {
      frissitesek[kulcs] = 0;
    });
    return fetch(gyoker + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates: frissitesek }),
    });
  }

  var SZAMLALO_KULCS = "movtech-kosar-extra-ujratoltes";

  function ujratoltesekSzama() {
    try {
      return parseInt(window.sessionStorage.getItem(SZAMLALO_KULCS) || "0", 10);
    } catch (e) {
      return 0;
    }
  }

  // Ha a kosár rendben van, a fék felenged: egy munkamenetben többször is
  // előfordulhat jogos takarítás.
  function nullaz() {
    try {
      window.sessionStorage.removeItem(SZAMLALO_KULCS);
    } catch (e) {
      /* privát böngészés */
    }
  }

  function ujratoltestJelol() {
    try {
      window.sessionStorage.setItem(SZAMLALO_KULCS, String(ujratoltesekSzama() + 1));
    } catch (e) {
      /* privát böngészés: a fék nélkül is működik, csak nincs számlálás */
    }
  }

  function takarit() {
    if (fut) return Promise.resolve();
    fut = true;
    return kosarLekeres()
      .then(function (kosar) {
        if (!kosar || !kosar.items || !kosar.items.length) return nullaz();
        // Van legalább egy szállítandó termék: az extrák jogosan maradnak.
        var vanSzallitando = kosar.items.some(function (tetel) {
          return tetel.requires_shipping;
        });
        if (vanSzallitando) return nullaz();
        var extrak = kosar.items.filter(function (tetel) {
          return beallitas.handles.indexOf(tetel.handle) > -1;
        });
        if (!extrak.length) return nullaz();
        return torles(
          extrak.map(function (tetel) {
            return tetel.key;
          })
        ).then(function () {
          // A kosár felülete (oldal, drawer, ikon) a törölt tételekkel a
          // képernyőn maradna, ezért újratöltjük. Ritka eset: csak akkor fut,
          // amikor az utolsó szállítandó termék is kikerült a kosárból.
          // Biztonsági fék: ha a törlés valamiért nem ül le (hálózati hiba),
          // az újratöltés ne pörögjön körbe-körbe.
          if (ujratoltesekSzama() < 2) {
            ujratoltestJelol();
            window.location.reload();
          }
        });
      })
      .catch(function () {
        // Csendben: a takarítás soha nem akaszthatja meg a vásárlást.
      })
      .then(function () {
        fut = false;
      });
  }

  // A téma minden kosár-műveletet AJAX-szal végez. A fetch-et átlátszóan
  // becsomagoljuk: a választ érintetlenül adjuk vissza, csak utána nézünk rá a
  // kosárra. Így nem kell a téma belső eseményeire támaszkodni, amelyek
  // törléskor nem is publikálódnak.
  var eredetiFetch = window.fetch;
  window.fetch = function () {
    var elsoParam = arguments[0];
    var cim =
      typeof elsoParam === "string"
        ? elsoParam
        : (elsoParam && elsoParam.url) || "";
    var kosarMuvelet = /\/cart\/(add|change|update|clear)(\.js)?/.test(cim);
    var valasz = eredetiFetch.apply(this, arguments);
    if (kosarMuvelet) {
      valasz
        .then(function () {
          setTimeout(takarit, 200);
        })
        .catch(function () {});
    }
    return valasz;
  };

  // Oldalbetöltéskor csak akkor nézünk rá, ha a Liquid szerint van tennivaló.
  if (beallitas.takaritas_kell) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        takarit();
      });
    } else {
      takarit();
    }
  }
})();
